import { getCookie } from "utils/cookies"
import { canUseDOM } from "utils/dom"

import { PARTNER_CAMPAIGN_BANNER_HEIGHT_CSS_VAR } from "./constants"

export const PARTNER_CAMPAIGN_CRF = "alliance"

export type PartnerCampaign = {
  crf: string
  programName: string
  promoCode: string
}

export type RawPartnerCampaignCookies = {
  crf: string
  programName: string
  promoCode: string
}

const normalizeValue = (value: string) => value.trim().toLowerCase()

const decodeCookieValue = (value: string) => {
  try {
    return decodeURIComponent(value)
  } catch (error) {
    return value
  }
}

export const matchPartnerCampaign = ({
  crf,
  programName,
  promoCode,
}: {
  crf?: string | null
  programName?: string | null
  promoCode?: string | null
}): PartnerCampaign | null => {
  const normalizedCrf = crf?.trim() || ""
  const normalizedProgramName = programName?.trim() || ""
  const normalizedPromoCode = promoCode?.trim() || ""

  if (
    !normalizedCrf ||
    normalizeValue(normalizedCrf) !== PARTNER_CAMPAIGN_CRF ||
    !normalizedProgramName ||
    !normalizedPromoCode
  ) {
    return null
  }

  return {
    crf: PARTNER_CAMPAIGN_CRF,
    programName: normalizedProgramName,
    promoCode: normalizedPromoCode,
  }
}

export const readRawPartnerCampaignCookies = (): RawPartnerCampaignCookies => {
  if (!canUseDOM()) {
    return {
      crf: "",
      programName: "",
      promoCode: "",
    }
  }

  return {
    crf: decodeCookieValue(getCookie("crf")),
    programName: decodeCookieValue(getCookie("program_name")),
    promoCode: decodeCookieValue(getCookie("promo_name")),
  }
}

export const readPartnerCampaign = (): PartnerCampaign | null => {
  if (!canUseDOM()) {
    return null
  }

  return matchPartnerCampaign(readRawPartnerCampaignCookies())
}

export const isPartnerCampaignSearchPath = (pathname?: string | null) =>
  pathname?.startsWith("/vacation-rentals/") || pathname === "/search"

export const isPartnerCampaignBannerPath = (pathname?: string | null) =>
  pathname === "/" || pathname === "/home" || pathname?.startsWith("/detail/")

export const shouldShowPartnerCampaignBanner = (pathname?: string | null) =>
  isPartnerCampaignBannerPath(pathname)

export { PARTNER_CAMPAIGN_BANNER_HEIGHT_CSS_VAR }
